import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';

import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SearchFilterComponent } from './search-filter/search-filter.component';
import { CronInputComponent } from './cron-input/cron-input.component';
import { FormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputMaskModule } from 'primeng/inputmask';

const COMPONENTS = [
  FooterComponent,
  NavbarComponent,
  SidebarComponent,
  SearchFilterComponent,
  CronInputComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CollapseModule.forRoot(),
    // PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    FormsModule,
    SelectButtonModule,
    InputMaskModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class ComponentsModule {}
